/**
 * @fileoverview POST handler for the "/custom_objects/:type_name" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameCacheKeys } from "./constants";
import type { PostCustomObjectsTypeNameProps, PostCustomObjectsTypeNameResult } from "./types";

export const postCustomObjectsTypeName = reactQueryMutationAdapter(
  customObjectsTypeNameCacheKeys,
  ({ typeName, custom_objects }: PostCustomObjectsTypeNameProps): Promise<PostCustomObjectsTypeNameResult> => {
    return fetch(`/custom_objects/${encodeURIComponent(typeName)}`, "POST", { custom_objects }, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
